'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  NONE: null,
  CSS_CLASS: null,
  CSS_ID: null,
  CSS_STYLE: null,
  EMAIL: null,
  PER_WIDGET_WRAPPER_HTML: null,
  WRAPPING_HTML: null
}));